import { CarouselItem, SendApiRequest } from '@inbox-demo-nx/types';
import {
  getMessageData,
  parseMessageData,
} from '@inbox-demo-nx/utils-data-utils';
import SendBird from 'sendbird';

export async function handleCarouselMessageSelection({
  message,
  selectedOption,
  sendApiRequest,
}: {
  message: SendBird.UserMessage;
  selectedOption: CarouselItem;
  sendApiRequest: SendApiRequest;
}) {
  const { channelUrl, messageId, data } = message;

  const originalData = parseMessageData(data);
  if (!originalData || !originalData.carousel) {
    return;
  }
  const originalCarousel = originalData.carousel;
  const updatedCarouselOptions: CarouselItem[] = originalCarousel.options.map(
    (item) =>
      item.name === selectedOption.name ? { ...item, isSelected: true } : item
  );
  const updatedMessageData = getMessageData({
    ...originalData,
    carousel: { ...originalCarousel, options: updatedCarouselOptions },
  });

  await sendApiRequest({
    type: 'editMessage',
    data: {
      channelUrl,
      messageId,
      params: {
        message_type: 'MESG',
        data: updatedMessageData,
      },
    },
  });
}
